<template>
  <svg class="rotate270" viewBox="0 0 24 24">
    <path d="M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z" />
  </svg>
</template>

<script>
export default {
  name: 'arrow-left',
};
</script>
